import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getThemeColor } from "../../utils/constants";
import CartMenuItem from "./CartMenuItem";

export default function CartMenu({ visible, setVisible, theme }) {
  const cart = useSelector((state) => state.cart);
  const { slug } = useParams();
  const navigate = useNavigate();

  const cartArray = Object.values(cart);
  const cartLength = cartArray.length;

  let totalPrice = 0;
  cartArray.forEach((item) => {
    totalPrice += item.productPrice * item.unit;
  });

  return (
    <div
      className={`minicart-right-drawer modal right fade ${
        visible ? "show d-block" : "d-none"
      }`}
      id="minicart-drawer">
      <div className="modal-dialog">
        <div className="modal-content">
          <div id="cart-drawer" className="block block-cart">
            <div className="minicart-header">
              <span
                className="close-cart"
                onClick={() => setVisible(false)}
                aria-label="Close">
                <i
                  className="an an-times-r"
                  aria-hidden="true"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  title="Close"></i>
              </span>
              <h4 className="fs-6">
                Your cart ({cartLength} {cartLength > 1 ? "Items" : "Item"})
              </h4>
            </div>
            <div className="minicart-content">
              {cartLength > 0 && (
                <ul className="clearfix">
                  {cartArray.map((item) => (
                    <CartMenuItem item={item} />
                  ))}
                </ul>
              )}
            </div>
            <div className="minicart-bottom">
              <div className="subtotal">
                <span>Total:</span>
                <span className="product-price">&#8358; {totalPrice}</span>
              </div>
              <button
                disabled={cartLength === 0}
                style={{
                  borderColor: getThemeColor(theme).backgroundColor,
                }}
                onClick={() => {
                  setVisible(false);
                  navigate(`/${slug}/checkout`, { state: cart });
                }}
                className={`w-100 p-2 my-2 btn btn-outline-primary proceed-to-checkout rounded ${theme}`}>
                Proceed to Checkout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
